import { MembershipOverviewItem, OverviewItemInfo, OverviewItemProps } from '../MembershipOverviewItem';
import { useGlobalState } from '../../../state/state';
import { changeAddressClick, getLoggedInMember } from '../../../state/helpers';
import { getAddressStr } from '../../../utils/stringHelper';

export const Address = () => {
  const [membershipDetails] = useGlobalState('memberDetails');
  const loggedInMember = getLoggedInMember(membershipDetails);
  const { residenceAddress, mailingAddress } = loggedInMember || {};
  const items: OverviewItemProps['items'] | any = [];

  const residenceAddressStr = getAddressStr(residenceAddress);
  const mailingAddressStr = getAddressStr(mailingAddress);

  const residenceAddressItem: OverviewItemInfo = {
    type: 'info',
    title: 'Residence address',
    subtitle: residenceAddressStr,
    key: 'residence-address',
    mask: 'subtitle',
  };
  items.push(residenceAddressItem);

  if (mailingAddress && residenceAddressStr !== mailingAddressStr) {
    const mailingAddressItem: OverviewItemInfo = {
      type: 'info',
      title: 'Mailing address',
      subtitle: mailingAddressStr,
      key: 'mailing-address',
      mask: 'subtitle',
    };
    items.push(mailingAddressItem);
  }

  items.push({
    type: 'link',
    text: 'Change address',
    key: 'change-your-info-link',
    onClick: changeAddressClick,
  });

  return (
    <MembershipOverviewItem
      id="address-overview"
      iconName="house-building-duotone"
      overviewText="Address"
      items={items}
    />
  );
};
